import styled from 'styled-components';

export const CheckboxGroupStyled = styled.div`
  .npsQuestionWrapper {
    padding: 0 0 16px;
    .npsQuestion {
      color: #031a32;
      padding: 10px 0;
      font-family: Mulish;
      font-size: 15px;
      font-style: normal;
      font-weight: 600;
    }
  }
  .checkbox-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    .checkBox-label {
      height: 40px;
      border-radius: 8px;
      padding: 12px 10px;
      border: 1px solid #E3E9EF;
      color: #031A32;
      font-size: 16px;
      line-height: 16px;
      font-family: Mulish;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      input.checkbox-input {
        width: 16px;
        height: 16px;
        border-radius: 2px;
        margin-right: 8px;
      }
      &.checkBox-checked {
        border: 1px solid #1976D2;
        color: #1976D2;
      }
      &.disable{
        pointer-events: none;
      }
    }
    
  }
  
`;
